import React, { useState, useEffect, useRef } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import login1 from "../../Assets/login-image2.svg";
import login2 from "../../Assets/login-image1.svg";
import login3 from "../../Assets/login-image3.svg";

const LoginImages = [
	{
	    id: 1,
	    img: login1,
	    title: "Digital Report Bank",
	    desc: "Access speedy reports from everywhere and anywhere.",
	},
	{
	    id: 2,
	    img: login2,
	    title: "Free Home Sample Pick-up",
	    desc: "Care at your Convenience. Get tested from the comfort of your home.",
	},
	{
	    id: 3,
	    img: login3,
	    title: "Free Call Consultationg",
	    desc: "Have a doubt? Clear it out.",
	},
];

function LoginCarousel(){
	return(
		<>
			<Carousel
              	autoPlay={true}
              	showIndicators={true}
              	showArrows={false}
              	showStatus={false}
              	showThumbs={false}
              	interval={2500}
              	infiniteLoop={true}
              	transitionTime={1000}
            >
              	{LoginImages.map((ImagesData, index) => (
	                <div key={index}>
	                  	<div className="loginSvg">
	                    	<img src={ImagesData.img} alt="loginphoto" />
	                  	</div>
	                  	<div className="TitleAndDesc">
	                    	<p className="loginImagetitle">{ImagesData.title}</p>
	                    	<p className="loginImagedesc">{ImagesData.desc}</p>
	                  	</div>
	                </div>
              	))}
            </Carousel>
		</>
	)
}
export default LoginCarousel;

